// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__b2NEN","svg":"Dialog_svg__0e4mu","header":"Dialog_header__m7aOQ","message":"Dialog_message__+Rks1"};